import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { DriverProcess, DriverProcessDetail, DriverProcessHistory } from 'app/models/driverProcess.model';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DriverProcessService {

    driverProcess: any[];
    onChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
    }

    getDriverProcess(companyId: number): Promise<Array<DriverProcess>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "driverprocess/" + companyId)
                .subscribe((response: any) => {
                    this.driverProcess = response;
                    this.onChanged.next(this.driverProcess);
                    resolve(response);
                }, reject);
        });
    }

    getDriverProcessControl(dpId:any): Promise<DriverProcess> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "driverprocess/controls/" + dpId)
                .subscribe((response: any) => {
                    this.driverProcess = response;
                    this.onChanged.next(this.driverProcess);
                    resolve(response);
                }, reject);
        });
    }

    getDriverProcessDetail(driverProcesId: number): Promise<Array<DriverProcessDetail>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "driverprocess/driverprocessdetail/" + driverProcesId)
                .subscribe((response: any) => {
                    this.driverProcess = response;
                    this.onChanged.next(this.driverProcess);
                    resolve(response);
                }, reject);
        });
    }

    getDriverProcessHistory(driverProcesId: number): Promise<Array<DriverProcessHistory>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "driverprocess/driverprocesshistory/" + driverProcesId)
                .subscribe((response: any) => {
                    this.driverProcess = response;
                    this.onChanged.next(this.driverProcess);
                    resolve(response);
                }, reject);
        });
    }

    add(driverProcess: DriverProcess): Promise<DriverProcess> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "driverprocess/add", driverProcess)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    addDetail(driverProcessDetail: DriverProcessDetail): Promise<DriverProcessDetail> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "driverprocess/addDetail", driverProcessDetail)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    updated(driverProcess: DriverProcess): Promise<DriverProcess> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "driverProcess/update", driverProcess)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    delete(driverProcess: DriverProcess): Promise<DriverProcess> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "driverProcess/delete", driverProcess)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

}
